import React, {useEffect, useState} from "react";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css'
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import TextField from '@mui/material/TextField';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';
import {Button} from "../Button";
import './index.css'
const moment = require('moment');



export const Calibrations: React.FC = () => {

    const adminUrl = process.env.REACT_APP_API_URL + "/api/calibrations/NSPM Admin/png"

    const hrsdPrimaryUrl = process.env.REACT_APP_API_URL +
	"/api/calibrations/NSPM HRSD Primary/png"
    
    // @ts-ignore
    return(
        <>
            <h1 style={{margin:0}}>Calibrations</h1>
	    <div>
	    <img src={adminUrl} width="75%" alt="NSPM Admin"/>
            </div>
	    <div>
	    <img src={hrsdPrimaryUrl} width="75%" alt="NSPM HRSD Primary"/>
            </div>

	    
        </>
    )
}
